export const ORDERS_REQUESTED = 'orders/ORDERS_REQUESTED'
export const ORDERS_SUCCEED = 'orders/ORDERS_SUCCEED'
export const ORDERS_FAIL = 'orders/ORDERS_FAIL'
export const UPDATE_ORDER = 'orders/UPDATE_ORDER'



// WEBPACK FOOTER //
// ./src/redux/orders/actionTypes.js